<template>
  <div>
    <a-tabs type="card" :activeKey="activeTabKey" @change="onTabChange">
      <a-tab-pane :key="'userSpecifiedKeywords'" :tab="'User-Specified Keywords ' + '(' + ((contentKeywordsData['excluded'] ? contentKeywordsData['excluded'].length : 0) + (contentKeywordsData['included'] ? contentKeywordsData['included'].length : 0)) + ')'">
        <a-collapse v-if="(contentKeywordsData['excluded'] && contentKeywordsData['excluded'].length > 0) || (contentKeywordsData['included'] && contentKeywordsData['included'].length > 0)" accordion>
          <template #expandIcon="props">
            <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
          </template>
          <a-collapse-panel v-if="contentKeywordsData['excluded'] && contentKeywordsData['excluded'].length > 0" header="Blacklisted keywords">
            <p v-for="(keyword, index) in contentKeywordsData['excluded']" :key="index">
              {{ keyword }}
            </p>
          </a-collapse-panel>
          <a-collapse-panel v-if="contentKeywordsData['included'] && contentKeywordsData['included'].length > 0" header="Whitelisted keywords">
            <p v-for="(keyword, index) in contentKeywordsData['included']" :key="index">
              {{ keyword }}
            </p>
          </a-collapse-panel>
        </a-collapse>
        <p v-else class="text-center">
          No user-specified keywords triggered
        </p>
      </a-tab-pane>
      <a-tab-pane :key="'contentAnalytics'" :tab="'Content Analytics ' + '(' + contentAnalyticsData.length + ')'">
        <div>
          <PaginationTable :columns="ContentAnalyticsColumns" :dataSource="contentAnalyticsData">
            <template slot="difference" slot-scope="{ record }">
              <span :style="{ color: '#e74c3c' }">
                {{ record.difference }}
              </span>
            </template>
          </PaginationTable>
        </div>
      </a-tab-pane>
      <a-tab-pane :key="'integrityAnalytics'" :tab="'Integrity Analytics ' + '(' + integrityAnalyticsData.length + ')'">
        <div>
          <p v-if="!integrityAnalyticsData.length" class="text-center">
            There is no record
          </p>
          <a-collapse accordion>
            <template #expandIcon="props">
              <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
            </template>
            <a-collapse-panel
              v-for="(integrityAnalyticItem, index) of integrityAnalyticsData"
              :key="index"
              :header="integrityAnalyticItem.label"
            >
              <p v-for="(itemChange, index) of integrityAnalyticItem.value" :key="index" :class="{'mb-0': index + 1 === integrityAnalyticItem.value.length}">
                <!-- <template v-if="incidentId"><router-link :to="'/incident/detail/' + incidentId + '/comparison#' + itemChange">{{ itemChange }}</router-link></template>
                <template v-else>{{ itemChange }}</template> -->
                {{ itemChange }}
              </p>
            </a-collapse-panel>
          </a-collapse>
        </div>
      </a-tab-pane>
      <a-tab-pane :key="'imageAnalytics'" :tab="'Image Analytics ' + '(' + imgAnalyticsData.length + ')'">
        <div>
          <PaginationTable :columns="ImgAnalyticsColumns" :dataSource="imgAnalyticsData" />
        </div>
      </a-tab-pane>
      <a-tab-pane :key="'staticMalwareScan'" :tab="'Javascript Malware Detection ' + '(' + staticMalwareScanDataMalicious.length + ')'">
        <div>
          <PaginationTable :columns="StaticMalwareScanColumns" :dataSource="staticMalwareScanData" />
        </div>
      </a-tab-pane>
      <a-tab-pane :key="'nlpTab'" :tab="'AI NLP' + '(' + (keywordSetsData.length + nlpClassifierWarningCount) + ')'">
        <a-tabs type="card" :activeKey="nlpActiveTabKey" @change="onNLPTabChange">
          <a-tab-pane :key="'nlpClassifier'" :tab="'NLP Classifier' + '(' + nlpClassifierWarningCount + ')'">
            <div v-if="nlpClassifierData.length > 0 || nlpClassifierWarningCount > 0">
              <a-row>
                <a-col :span="24">
                  <a-card v-if="en_probability < 0.5 || en_proportion< 0.5" title="Language Check Result">
                    <LanguagePredictionResult :englishProbability="en_probability" :englishProportion="en_proportion" />
                  </a-card>
                </a-col>
              </a-row>
              <a-card :title="nlp_text_difference ? 'Text difference' : 'No text change detected'">
                <a-row v-if="nlp_text_difference">
                  <a-alert :message="nlp_text_difference" type="warning" />
                </a-row>
                <a-row v-else>
                  <div>
                    The text in the website does not change.
                  </div>
                </a-row>
              </a-card>
              <div v-if="nlpClassifierData.length > 0">
                <a-row v-for="result in nlpClassifierData" :key="result['modelName']">
                  <a-card :title="transformModelName(result['modelName']) + ' Prediction'">
                    <PredictionResult :defacedConfidence="result['modelConfident']" :defacedThreshold="result['defacedThreshold']" />
                    <a-row style="display:flex; justify-content: flex-end;">
                      <a-button type="primary" @click="nlp_engine_run_analysis(result['modelName'])">
                        Show Model Explainability Tool
                      </a-button>
                    </a-row>
                  </a-card>
                </a-row>
              </div>
            </div>
            <p v-else class="text-center">
              No result for NLP Classifier
            </p>
          </a-tab-pane>
          <a-tab-pane :key="'nlpKeywords'" :tab="'NLP Keywords ' + '(' + keywordSetsData.length + ')'">
            <div>
              <PaginationTable :columns="KeywordSetsColumns" :dataSource="keywordSetsData">
                <template slot="contexts" slot-scope="{ record }">
                  <!-- loop through all the matched contexts -->
                  <div v-for="(context, index) in record.contexts" :key="index">
                    <a-tag v-if="context.line_num" color="orange">
                      Line {{ context.line_num }}
                    </a-tag>
                    <!-- loop through the split out parts of each context to highlight accordingly -->
                    <span v-for="(part, partIndex) in context.context" :key="partIndex">
                      <code v-if="partIndex % 2 == 0">
                        {{ part }}
                      </code>
                      <code v-if="partIndex % 2 != 0" style="background-color: yellow">
                        {{ part }}
                      </code>
                    </span>
                  </div>
                </template>
              </PaginationTable>
            </div>
          </a-tab-pane>
        </a-tabs>
      </a-tab-pane>
      <a-tab-pane :key="'vcdTab'" :tab="'Video Change Detection' + ' (' + getChangedVcdResults().length + ')'">
        <div v-if="getChangedVcdResults().length > 0">
          <p class="vcd-summary">{{ vcdEngineData.message }}</p>
          <div class="vcd-results-grid">
            <div v-for="(result, index) in getChangedVcdResults()" :key="index" class="vcd-result-card">
              <div v-if="result.error" class="vcd-result-error">
                <a-icon type="warning" /> <strong>Issue:</strong> {{ result.error }}
              </div>
              <div class="vcd-result-card__controls">
                <a-radio-group :value="getVcdImageView(index, result)" @change="(e) => setVcdImageView(index, e.target.value)">
                  <a-radio-button value="before" :disabled="!result.before_url">{{ getVcdBeforeLabel() }}</a-radio-button>
                  <a-radio-button value="after" :disabled="!result.after_url">Current</a-radio-button>
                </a-radio-group>
              </div>
              <div class="vcd-image-preview">
                <img
                  v-if="getVcdImageView(index, result) === 'before' && result.before_url"
                  :src="result.before_url"
                  class="vcd-thumbnail"
                @click="openVcdImageModal(result.before_url)"
                />
                <img
                  v-else-if="getVcdImageView(index, result) === 'after' && result.after_url"
                  :src="result.after_url"
                  class="vcd-thumbnail"
                @click="openVcdImageModal(result.after_url)"
                />
                <p v-else class="mb-0 text-muted">No frame image available for this view</p>
              </div>
              <a :href="result.video_url" target="_blank" rel="noopener noreferrer" class="vcd-result-url">
                {{ result.video_url }}
              </a>
            </div>
          </div>
        </div>
        <p v-else class="text-center">
          No video changes detected
        </p>
      </a-tab-pane>
    </a-tabs>
    <div>
      <a-modal
        :bodyStyle="{ 'height': '80vh',
                      'overflow': 'scroll',
                      'overflow-x':'hidden'}"
        style="overflow: scroll;"
        :visible="show_nlp_analysis_modal"
        title="Model Explainability Result"
        width="75%"
        :closable="true"
        okText="Save"
        @ok="nlp_engine_update_configurations"
        @cancel="()=>{show_nlp_analysis_modal = false}"
      >
        <NLPAnalysisResult :model="model" :urlID="urlID" :diff="nlp_text_difference" :runOnstart="true" :modalClosed="show_nlp_analysis_modal" @change="update_ignored_word_from_child" />
      </a-modal>
      <a-modal
        :visible="showVcdImageModal"
        :footer="null"
        :closable="true"
        width="70%"
        centered
        title="Video frame preview"
        @cancel="showVcdImageModal = false"
      >
        <div class="vcd-image-modal">
          <img :src="selectedVcdImage" alt="Video frame preview" />
        </div>
      </a-modal>
    </div>
  </div>
</template>

<script>
  import capitalizeFilter from '@shared/filters/capitalize.filter';
  import LanguagePredictionResult from "./NLPComponents/LanguagePredictionResult";
  import PredictionResult from "./NLPComponents/PredictionResult";
  import ApiService from '@shared/services/api.service';
  import NLPAnalysisResult from "./NLPComponents/NLPAnalysisResult";
  import { notification } from 'ant-design-vue';
  const ContentAnalyticsColumns = [
    {
      title: 'No.',
      dataIndex: 'index',
      width: '80px'
    },
    {
      title: 'Description',
      dataIndex: 'description'
    },
    {
      title: 'Current Alert Value',
      dataIndex: 'lastVerifiedValue',
      slot: 'lastVerifiedValue'
    },
    {
      title: 'Baseline Value',
      dataIndex: 'baselineValue',
      slot: 'baselineValue'
    },
    {
      title: 'Difference',
      dataIndex: 'difference',
      slot: 'difference',
      width: '120px'
    }
  ];

  const ContentAnalyticsColumnsLastIncident = [
    {
      title: 'No.',
      dataIndex: 'index',
      width: '80px'
    },
    {
      title: 'Description',
      dataIndex: 'description'
    },
    {
      title: 'Current Alert Value',
      dataIndex: 'lastVerifiedValue',
      slot: 'lastVerifiedValue'
    },
    {
      title: 'Last Alert Value',
      dataIndex: 'lastIncidentValue',
      slot: 'baselineValue'
    },
    {
      title: 'Difference',
      dataIndex: 'difference',
      slot: 'difference',
      width: '120px'
    }
  ];

  const ImgAnalyticsColumns = [
    {
      title: 'No.',
      dataIndex: 'description',
      width: '150px'
    },
    {
      title: '% Change Detected',
      dataIndex: 'changeDetected',
      slot: 'changeDetected'
    },
    {
      title: '% Change Alert Threshold',
      dataIndex: 'changeAlertThreshold',
      slot: 'changeAlertThreshold'
    }
  ];

  const StaticMalwareScanColumns = [
    {
      title: 'No.',
      dataIndex: 'number',
      width: '150px'
    },
    {
      title: 'Script URL/Name',
      dataIndex: 'scriptName',
      slot: 'scriptName'
    },
    {
      title: 'Detection',
      dataIndex: 'detection',
      slot: 'detection'
    }
  ];

  const KeywordSetsColumns = [
    {
      title: 'No.',
      dataIndex: 'number',
      width: '150px'
    },
    {
      title: 'Keyword',
      dataIndex: 'keyword',
      slot: 'keyword'
    },
    {
      title: 'Set Name',
      dataIndex: 'set_name',
      slot: 'set_name'
    },
    {
      title: 'Count',
      dataIndex: 'count',
      slot: 'count'
    },
    {
      title: 'Context',
      dataIndex: 'contexts',
      slot: 'contexts'
    }
  ];

  export default {
    name: "VerifyResultTable",
    components: {
      LanguagePredictionResult,
      PredictionResult,
      NLPAnalysisResult,
    },
    props: {
      changesDetected: {
        type: Object,
        default: () => {}
      },
      incidentId: {
        type: String,
        default: ""
      },
      comparisonType: {
        type: String,
        default: "baseline"
      }
    },
    data() {
      return {
        ContentAnalyticsColumns,
        ImgAnalyticsColumns,
        StaticMalwareScanColumns,
        KeywordSetsColumns,
        activeTabKey: 'contentAnalytics',
        contentKeywordsData: [],
        contentAnalyticsData: [],
        integrityAnalyticsData: [],
        imgAnalyticsData: [],
        staticMalwareScanData: [],
        staticMalwareScanDataMalicious: [],
        keywordSetsData: [],
        nlpClassifierData: [],
        nlpClassifierWarningCount: 0,
        nlpActiveTabKey: 'nlpClassifier',
        vcdEngineData: null,
        vcdImageViewByIndex: {},
        en_probability: 0,
        en_proportion: 0,
        nlp_text_difference: "",
        urlID: 0,
        model: undefined,
        show_nlp_analysis_modal: false,
        showVcdImageModal: false,
        selectedVcdImage: '',
        using_policy: false,
        updated: false,
      }
    },
    watch: {
      changesDetected: {
        deep: true,
        handler() {
          this.updateData();
        }
      }
    },
    mounted() {
      this.updateData();
    },
    methods: {
      async nlp_engine_run_analysis(modelName){
        let model_name = "";
        if (modelName.toLowerCase().includes("distilbert")){
          model_name = "distilbert";
        } else if (modelName.toLowerCase().includes("xgb")){
          model_name = "xgboost";
        }
        await ApiService.get(`urls/${this.urlID}/nlp/config`).then(res=>{
          const config = res.filter(item=>item.modelName == model_name);
          if (config.length > 0){
            const word_ignored = JSON.parse(config[0].wordsIgnored);
            this.model = {
              model: config[0].modelName,
              threshold: config[0].defaceThreshold,
              words_ignored: word_ignored,
              policy: config[0].policyID,
            };
            this.using_policy = config[0].policyID > 0;
            this.show_nlp_analysis_modal = true;
            this.updated = false;
          }
        }).catch(e=>{
          console.log(e);
        });
      },
      update_ignored_word_from_child(config){
        this.updated = true;
        this.model.words_ignored = config.words_ignored;
      },
      async nlp_engine_update_configurations(){
        if (!this.updated){
          this.show_nlp_analysis_modal = false;
          return;
        }
        const payload = this.model;
        payload.policy = this.using_policy ? this.model.policy : 0;
        await ApiService.post(`urls/${this.urlID}/nlp/config`, payload).then(res=>{
          if (res === "success" || res === "not updated"){
            this.show_nlp_analysis_modal = false;
          } else {
            notification.open({
              message: 'Error update configurations',
              description: 'The configuration update failed, please check and try again later!',
              duration: 6
            });
            return;
          }
        }).catch(e=>{
          console.log(e);
        });
      },
      onTabChange(tabKey) {
        this.activeTabKey = tabKey;
      },
      onNLPTabChange(tabKey) {
        this.nlpActiveTabKey = tabKey;
      },
      getVcdImageView(index, result) {
        if (this.vcdImageViewByIndex[index]) {
          return this.vcdImageViewByIndex[index];
        }
        return result.before_url ? 'before' : 'after';
      },
      getChangedVcdResults() {
        if (!this.vcdEngineData || !Array.isArray(this.vcdEngineData.results)) {
          return [];
        }
        return this.vcdEngineData.results.filter((result) => result && result.is_changed);
      },
      setVcdImageView(index, view) {
        this.$set(this.vcdImageViewByIndex, index, view);
      },
      getVcdBeforeLabel() {
        return this.comparisonType === 'previous' ? 'Previous' : 'Baseline';
      },
      fetchContentAnalytics(contentAnalyticsData) {
        const result = Object.entries(contentAnalyticsData)
                .map(([key, value], index) => this.mapContentAnalytics([key, value], index))
                .filter((item) => !!item.description);

        if ('custom_elements' in contentAnalyticsData) {
            for (const value of contentAnalyticsData.custom_elements) {
                result.push({
                    description: 'Custom Element: ' + value.name,
                    index: result.length + 1,
                    lastVerifiedValue: value.current,
                    baselineValue: value.baseline,
                    lastIncidentValue: value.last_incident,
                    difference: value.difference
                });
            }
        }

        if (result.length > 0 && result[0].lastIncidentValue !== undefined) {
          this.ContentAnalyticsColumns = ContentAnalyticsColumnsLastIncident;
        }

        return result;
      },
      fetchIntegrityAnalytics(integrityAnalyticsData) {
        return Object.entries(integrityAnalyticsData).map(([key, value]) => {
          let label = '';
          switch (key) {
            case 'css': {
              label = 'CSS Changes';
              break;
            }
            case 'div': {
              label = 'Divisions Changes';
              break;
            }
            case 'href': {
              label = 'Href Links Changes';
              break;
            }
            case 'img': {
              label = 'Images Changes';
              break;
            }
            case 'line_num': {
              label = '# of HTML Lines Changes';
              break;
            }
            case 'script': {
              label = 'Javascripts Changes';
              break;
            }
            case 'iframe': {
              label = 'Iframes Changes';
              break;
            }
            case 'form': {
              label = 'Forms Changes';
              break;
            }
            case 'custom_element': {
                label = 'Custom Elements Changes';
                break;
            }
            default: {
              label = capitalizeFilter(label) + ' Changes';
            }
          }
          return {
            label,
            value: value || []
          };
        });
      },
      fetchImgAnalytics(imageEngine) {
        return imageEngine.map((value, index) => ({
          description: `${index + 1}. Region #${value.crop_number}`,
          changeDetected: value.result_percentage,
          changeAlertThreshold: value.threshold_percentage
        }));
      },
      formatStaticMalwareScan(staticMalwareScan) {
        if (!staticMalwareScan) {
          return [];
        }

        let staticMalwareScanMaliciousFirst = staticMalwareScan.filter(value => value.malicious);
        staticMalwareScanMaliciousFirst = staticMalwareScanMaliciousFirst.concat(staticMalwareScan.filter(value => !value.malicious));

        return staticMalwareScanMaliciousFirst.map((value, index) => {
          let detectionMessage = null;
          if (value.malicious) {
            detectionMessage = `Threat found: ${value.threat_family}.${value.threat_type}`;
          } else if (value.error) {
            detectionMessage = "An error occurred while scanning this file";
          } else {
            detectionMessage = "No threat found";
          }

          return {
            number: `${index + 1}`,
            scriptName: value.name,
            detection: detectionMessage,
          }
        });
      },
      formatStaticMalwareScanMalicious(staticMalwareScan) {
        if (!staticMalwareScan) {
          return [];
        }

        const staticMalwareScanMaliciousOnly = staticMalwareScan.filter(value => value.malicious);
        return this.formatStaticMalwareScan(staticMalwareScanMaliciousOnly);
      },
      formatKeywordSets(keywordSetsEngine) {
        if (!keywordSetsEngine) {
          return [];
        }

        return keywordSetsEngine.map((value, index) => {

          let prettyContexts = value.contexts;
          prettyContexts = prettyContexts.slice(0, 5); // choose first 5 to show only
          prettyContexts = prettyContexts.map((entry) => {
            if (entry instanceof Object && 'context' in entry) {
              // remove newline chars so that the context appears as one line only
              const re = /[\r\n]/g;
              const contextStr = entry.context.replaceAll(re, "");
              return {
                context: this.caseInsensitiveWordSplit(contextStr, value.keyword),
                line_num: entry.line_number
              };
            } else {
              // Handle legacy contexts that have no line number information (just an array of strings)
              // remove newline chars so that the context appears as one line only
              const re = /[\r\n]/g;
              const contextStr = entry.replaceAll("\r|\n", "");
              return {
                context: this.caseInsensitiveWordSplit(contextStr, value.keyword),
                line_num: null
              };
            }
          });

          return {
            number: `${index + 1}`,
            keyword: value.keyword,
            set_name: value.set_name,
            count: value.contexts.length,
            contexts: prettyContexts,
          }
        });
      },
      formatNLPClassifier(nlpResult){
        if (!nlpResult || nlpResult.length === 0) {
          return [];
        }
        if (nlpResult['difference']){
          this.nlp_text_difference = nlpResult['difference'];
        }
        if (nlpResult['url_id']){
          this.urlID = nlpResult['url_id'];
        }
        const predictions = nlpResult['predictions'];
        const warnings = predictions.filter(x => x.modelConfident > x.defacedThreshold);
        this.nlpClassifierWarningCount = warnings ? warnings.length: 0;
        if (predictions.length > 0){
          const language_check_result = predictions.reduce((prev, current)=>{
            return (prev.englishProbability > current.englishProbability || prev.englishProportion < current.englishProportion) ? current : prev;
          });
          this.en_probability = language_check_result.englishProbability;
          this.en_proportion = language_check_result.englishProportion;
        }
        const accept_model_names = ['distilbert', 'distilbert+', 'xgboost', 'xgb', 'xgb+']
        const filtered_result = predictions.filter(x=>accept_model_names.includes(x.modelName.toLowerCase()));
        return filtered_result;
      },
      transformModelName(name){
        switch(name.toLowerCase()){
          case 'distilbert':
            return 'Model T';
          case 'distilbert+':
            return 'Model T';
          case 'xgboost':
            return 'Model X';
          case 'xgb':
            return 'Model X';
          case 'xgb+':
            return 'Model X';
        }
      },
      /**
       * ---> mapContentAnalytics > decodeBase64ToUtf8 > Display in PaginationTable
       * Decodes a base64 string to UTF-8 (utf8mb4 compatible) if prefixed with [B64:].
       * Returns the original string if no prefix or if decoding fails.
       */
      decodeBase64ToUtf8(str) {
        if (!str || typeof str !== 'string') {
          return str;
        }
        
        const BASE64_PREFIX = '[B64:]';
        
        // Only decode if explicitly marked with [B64:] prefix
        if (!str.startsWith(BASE64_PREFIX)) {
          return str;
        }
        
        try {
          // Extract the base64 content after the prefix
          const base64Content = str.slice(BASE64_PREFIX.length);
          // Decode base64 to binary string
          const binaryString = atob(base64Content);
          // Convert binary string to Uint8Array for proper UTF-8 decoding
          const bytes = new Uint8Array(binaryString.length);
          for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }
          // Decode as UTF-8 (supports full utf8mb4 including 4-byte chars like emojis)
          return new TextDecoder('utf-8').decode(bytes);
        } catch (e) {
          // If decoding fails, return original string
          return str;
        }
      },
      caseInsensitiveWordSplit(haystack, needle) {
        const escapedNeedleBuilder = [];
        for (let i = 0; i < needle.length; i++) {
          const charAsHex = needle.charCodeAt(i).toString(16).padStart(4, '0');
          escapedNeedleBuilder.push(charAsHex);
        }
        const escapedNeedle = "\\u" + escapedNeedleBuilder.join("\\u");
        const re = new RegExp("(\\W|^)(" + escapedNeedle + ")(\\W|$)", "ig");

        const parts = [];
        let offset = 0;
        let match = null;
        while ((match = re.exec(haystack)) !== null) {
          const beforeChar = match[1];
          const afterChar = match[3];
          const needle = match[2];
          const index = match.index;

          // We know the match index, but the match index starts at the whitespace char
          // so we take the string from the last known "stop offset" until the index + whitespace char
          parts.push(haystack.substr(offset, index + beforeChar.length - offset));
          parts.push(needle);

          // We set the new offset = match index + the whitespace char before + matched word itself
          offset = index + beforeChar.length + needle.length;
        }
        parts.push(haystack.substr(offset));

        return parts;
      },
      /**
       * ---> fetchContentAnalytics > mapContentAnalytics > contentAnalyticsData (displayed in PaginationTable)
       * Maps raw content analytics data to display format.
       * For 'title' key, decodes base64 values to UTF-8 if needed.
       */
      mapContentAnalytics([key, value], index) {
        let description = '';
        let lastVerifiedValue = value.current;
        let baselineValue = value.baseline;
        let lastIncidentValue = value.last_incident;

        switch (key) {
          case 'title': {
            description = 'HTML Title';
            // Decode base64 to UTF-8 (utf8mb4) for title values if encoded
            lastVerifiedValue = this.decodeBase64ToUtf8(value.current);
            baselineValue = this.decodeBase64ToUtf8(value.baseline);
            lastIncidentValue = this.decodeBase64ToUtf8(value.last_incident);
            break;
          }
          case 'css': {
            description = 'Cascading Styles Sheets';
            break;
          }
          case 'div': {
            description = 'Divisions';
            break;
          }
          case 'href': {
            description = 'Href Links';
            break;
          }
          case 'img': {
            description = 'Images';
            break;
          }
          case 'line_num': {
            description = '# of HTML Lines';
            break;
          }
          case 'script': {
            description = 'Javascripts';
            break;
          }
          case 'iframe': {
            description = 'Iframes';
            break;
          }
          case 'form': {
              description = 'Forms';
              break;
            }
          case 'hash': {
            description = 'Full Page Signature';
            break;
          }
          default: {
          }
        }
        return {
          description,
          index: index + 1,
          lastVerifiedValue,
          baselineValue,
          lastIncidentValue,
          difference: value.difference
        };
      },
      updateData() {
        this.contentKeywordsData = (this.changesDetected.content_engine_keywords || {})
        this.contentAnalyticsData = this.fetchContentAnalytics((this.changesDetected.content_engine) || {});
        this.integrityAnalyticsData = this.fetchIntegrityAnalytics((this.changesDetected.integrity_engine) || {});
        this.imgAnalyticsData = this.fetchImgAnalytics((this.changesDetected.image_engine) || []);

        this.staticMalwareScanData = this.formatStaticMalwareScan((this.changesDetected.static_malware_scan_engine) || []);
        this.staticMalwareScanDataMalicious = this.formatStaticMalwareScanMalicious((this.changesDetected.static_malware_scan_engine) || [])

        this.keywordSetsData = this.formatKeywordSets((this.changesDetected.keyword_sets_engine) || []);
        this.nlpClassifierData = this.formatNLPClassifier((this.changesDetected.nlp_deeplearning_engine_result) || []);
        this.vcdEngineData = this.changesDetected.vcd_engine || null;
        this.vcdImageViewByIndex = {};
        // If there is a tab that has data, we focus on that tab first
        if (this.contentAnalyticsData.length > 0) {
          this.activeTabKey = 'contentAnalytics';
        } else if (this.integrityAnalyticsData.length > 0) {
          this.activeTabKey = 'integrityAnalytics';
        } else if (this.imgAnalyticsData.length > 0) {
          this.activeTabKey = 'imgAnalytics';
        } else if (this.staticMalwareScanDataMalicious.length > 0) {
          this.activeTabKey = 'staticMalwareScan';
        } else if (this.nlpClassifierData.length > 0) {
          this.activeTabKey = 'nlpTab';
          this.nlpActiveTabKey = 'nlpClassifier';
        } else if (this.keywordSetsData.length > 0) {
          this.activeTabKey = 'nlpTab';
          this.nlpActiveTabKey = 'nlpKeywords';
        } else if (this.vcdEngineData && this.vcdEngineData.results && this.vcdEngineData.results.length > 0) {
          this.activeTabKey = 'vcdTab';
        }
      },
      openVcdImageModal(imageData) {
        this.selectedVcdImage = imageData;
        this.showVcdImageModal = true;
      },
    }
  }
</script>

<style scoped>
.vcd-result-card {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 14px;
  margin-bottom: 12px;
  background: #fff;
}

.vcd-summary {
  margin: 0 0 12px 2px;
  font-size: 13px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.75);
}

.vcd-results-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.vcd-result-url {
  display: inline-block;
  margin-top: 10px;
  white-space: normal;
  word-break: break-all;
  color: #1890ff;
  line-height: 1.35;
  width: 100%;
}

.vcd-result-card__controls {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  margin-bottom: 10px;
}

.vcd-result-error {
  color: #ad6800;
  margin-bottom: 10px;
  font-size: 12px;
  background: #fffbe6;
  border: 1px solid #ffe58f;
  border-radius: 4px;
  padding: 6px 10px;
}

.vcd-image-preview {
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  width: 100%;
  max-width: 100%;
}

.vcd-thumbnail {
  width: 100%;
  height: auto;
  object-fit: contain;
  border-radius: 2px;
  cursor: pointer;
  transition: opacity 0.3s;
}

.vcd-thumbnail:hover {
  opacity: 0.8;
}

.vcd-image-modal {
  display: flex;
  justify-content: center;
  align-items: center;
}

.vcd-image-modal img {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
}

@media (max-width: 1600px) {
  .vcd-results-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 1100px) {
  .vcd-results-grid {
    grid-template-columns: 1fr;
  }
}
</style>
